import monitorService from '@/services/monitor.service';
import { filterRulesMapped } from '@/tools/filterRules';
import { PIMS_LOGS_HEADERS } from './constants';

export default {
    name: "PimsLogsComponent",
    components: {},
    data() {
        return {
            tableDataKey: "pimsLogs",
            tableHeaders: PIMS_LOGS_HEADERS,
            tableFilterRules: {},
            tableData: [],
            loading: false
        };
    },
    async mounted() {
        this.loading = true;
        try {
            this.updateTable();
            this.setTableFilterRules();
        } finally {
            this.loading = false;
        }
    },
    methods: {
        async refreshTable() {
            try {
                this.loading = true;
                await this.updateTable();
            } finally {
                this.loading = false;
            }
        },
        async updateTable() {
            const logs = await monitorService.getPimsLogs();
            const result = [];
            if (logs && logs.length > 0) {
                for (const log of logs) {
                    if (log && log.response && log.response.config && log.response.config.data) {
                        result.push(JSON.parse(log.response.config.data));
                    }
                }
            }
            result.forEach(item => {
                if (item.ResumenOrigen) {
                    item.ResumenOrigen = JSON.stringify(item.ResumenOrigen);
                }
            });

            this.tableData.cleanAndUpdate(result);
        },
        setTableFilterRules() {
            this.tableFilterRules = {}
            this.tableHeaders.forEach(header => {
                this.tableFilterRules[header.value] = filterRulesMapped[header.filterType]
            })
        },
    }
};
